import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { actionsStyle } from './Dialog.css';

type Props = ComponentPropsWithRef<'div'>;

export const DialogActions = ({ children, ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(actionsStyle, delegated.className)}>
      {children}
    </div>
  );
};
